module.exports = __webpack_public_path__ + "static/media/pin-agency.75234e7b.svg";